import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { PacienteFilter } from 'src/app/homecare/paciente/paciente-filter';
import { Paciente } from 'src/app/homecare/paciente/paciente.model';
import { PacienteService } from 'src/app/homecare/paciente/paciente.service';
import { environment } from 'src/environments/environment';
import { Status } from '../../framework/default.model';
import { AutocompleteComponent } from '../../framework/input-components/autocomplete-component.abstract';
import { DateTimeUtil } from '../../framework/utils/date-time-util';
import { IdadeUtil } from '../../framework/utils/idade-util';
import { StringUtil } from '../../framework/utils/string-util';
import { ListaResultset } from '../../list/lista-resultset.interface';


@Component({
  selector: 'app-autocomplete-paciente',
  templateUrl: './autocomplete-paciente.component.html',
  styleUrls: ['./autocomplete-paciente.component.css']
})
export class AutocompletePacienteComponent extends AutocompleteComponent<Paciente> implements OnDestroy, AfterViewChecked {

  private novaAbaCadastroDePaciente = null;

  @Input() obrigatorio = false;
  @Input() placeholder = 'Paciente';
  @Input() bloqueado   = false;
  @Input() exibirInformacoesAdicionais = true;
  @Input() exibirAtalhoNovoPaciente = true;
  
  @ViewChild('autocomplete') autocompleteViewChild: AutoComplete;

  formDisabled = false;
  autocompleteName = 'paciente';

  itemSelecionado: Paciente;
  resultset: Paciente[];
  resultsetMaxSize = environment.localizador_max_size;

  private subject: Subject<Paciente>;

  private idadeUtil: IdadeUtil;
  private dateTimeUtil: DateTimeUtil;

  constructor(
    private pacienteService: PacienteService
    , private changeDetectorRef?: ChangeDetectorRef
  ) {
    super();

    this.subject = new Subject();
    this.idadeUtil = new IdadeUtil();
    this.dateTimeUtil = new DateTimeUtil();
  }
  
  ngAfterViewChecked(): void {
    this.carregarInformacaoDeIdadeEDataDeNascimento();
  }

  private carregarInformacaoDeIdadeEDataDeNascimento(): void {
    if ( this.formDisabled && this.itemSelecionado ) {
      if ( !this.itemSelecionado.dataNascimentoDiaMesAno && this.itemSelecionado.dataNascimento ) {
        setTimeout(() => {
          this.itemSelecionado.idadePorExtenso         = this.idadeUtil.getIdadeDescritiva( this.itemSelecionado.dataNascimento );
          this.itemSelecionado.dataNascimentoDiaMesAno = this.dateTimeUtil.dateToDiaMesAno( this.itemSelecionado.dataNascimento );
        }, 0);
      }
    }
  }

  ngOnDestroy(): void {
    if ( this.subject ) {
      this.subject.complete();
    }
    this.idadeUtil = null;
    this.dateTimeUtil = null;
  }

  getObjetoSelecionado(): Paciente {
    return this.itemSelecionado;
  }

  setObjetoSelecionado(o: Paciente): void {
    this.itemSelecionado = o;
  }

  getSubject(): Subject<Paciente> {
    return this.subject;
  }

  search(event: any): void {
    const filter: PacienteFilter = {
      status: Status.ATIVO
    };

    if ( StringUtil.comecaComNumero(event.query, 2) ) {
      filter.cpf = event.query;
    }
    else {
      filter.nome = event.query;
    }

    this.pacienteService
        .listar(filter)
        .pipe(
          map((response: ListaResultset<Paciente>) => {
            response.content
              .forEach((paciente: Paciente) => {
                paciente.idadePorExtenso         = this.idadeUtil.getIdadeDescritiva( paciente.dataNascimento );
                paciente.dataNascimentoDiaMesAno = this.dateTimeUtil.dateToDiaMesAno( paciente.dataNascimento );
              })

            return response;
          })
        )
        .subscribe((response: ListaResultset<Paciente>) => {
          this.resultset = response.content;
        });
  }

  focus(): void {
    if ( this.autocompleteViewChild ) {
      this.autocompleteViewChild.focusInput();
    }
  }

  onBlur(event): void {
    if ( this.changeDetectorRef ) {
      this.changeDetectorRef.detectChanges();
    }
  }


  public irParaCadastroDePaciente(): void {
    if ( this.novaAbaCadastroDePaciente ) {
      this.novaAbaCadastroDePaciente.close();
    }
    const url = '/homecare/paciente/0';
    const horizontal = 0;
    this.novaAbaCadastroDePaciente = window.open(url, "_blank", "resizable=yes, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=" + horizontal + " top=100 " );
  }

}
